import React from 'react';
import { useState, useEffect, useRef, Suspense, lazy } from 'react'
import { ChallengeTypeContainer, CommonRightCard, CompletePointCardNew, ProfileContainer } from '../styles'
import { CalendarChallengeIcon, LocationChallengeIcon, RewardsChallengeIcon, PeopleChallengeIcon, StepsIcon, CaloriesIcon, DisatanceIcon, InviteChallengeIcon, AddUserIcon, RemoveUserIcon } from '../../../utils/icons'
import { Divider, ManagerIconContainer, NameInitials } from '../../Manager/styles'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux';
import { commaSeperator, convertDateInTimezone, convertMilesToKm, convertMonthFromDate, getInitials, getTimeToShow, rankingDashboard } from '../../../utils/methods'
import moment from 'moment'
import Waiting from '../../Waiting';
import { isEmpty, isNull } from 'lodash'
import LazyImage from '../../common/LazyImage/LazyImage'
import { ImageUrl } from '../../../utils/constants'
import { useDispatch } from 'react-redux';
const InviteAmigoPopUp = lazy(() => import('../InviteAmigoPopUp/inviteChallengePopup'))
import { useTranslation } from 'react-i18next';
import { joinOrLeaveChallenge, getInviteAmigosList } from '../../../redux/actions';
import {CommonButtonBorder} from '../../common/commonStyles'
import {HoverIconWrapper} from '../styles'
import Timer from '../../EventDetails/timer';

function ClassicTeamRightScreen({ tabValue, challenge, user, teamChallenge, userId, history, getUserOverviewDetails, onAddUserPopup, role, hasCompanyInRoute, companyId }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const challengeAttendees = useSelector((state) => state.challenges.challengeAttendees);
  const userChallengeDetails = useSelector((state) => state.challenges.userChallengeDetails);
  const [isButtonDisabled, setIsButtonDisabled] = React.useState(false);
  const [showInviteAmigoPopup, setShowInviteAmigoPopup] = useState(false)
  let lang = localStorage.getItem("lang");

  const [time, setTime] = useState(getTimeToShow(challenge, 'challenge'));
  const intervalRef = useRef(null);


  useEffect(() => {
    intervalRef.current = window.setInterval(() => {
      setTime(getTimeToShow(challenge, 'challenge'));
    }, 1000);

    return () => {
      window.clearInterval(intervalRef.current);
    };
  }, [challenge]);


  useEffect(() => {
    if (intervalRef.current) {
      window.clearInterval(intervalRef.current);
    }

    intervalRef.current = window.setInterval(() => {
      setTime(getTimeToShow(challenge, 'challenge'));
    }, 1000);

    return () => window.clearInterval(intervalRef.current);
  }, [challenge]);


  useEffect(() => {
    if (challenge?.id && challenge?.event_type && userId) {
      getUserOverviewDetails(challenge.id, challenge.event_type, userId, companyId);
    }
  }, [challenge?.id, challenge?.event_type, userId]);


  const showHideInviteAmigoPopup = () => {
    const updatedPopupState = !showInviteAmigoPopup;
    setShowInviteAmigoPopup(updatedPopupState);

    if (updatedPopupState) {
      dispatch(getInviteAmigosList(userId, challenge.id));
    }
  };

  const hideInviteAmigoPopup = () => {
    setShowInviteAmigoPopup(false);
  };


  let challengeOver = true;
  time.map((step) => {
    const values = step.split(' ');
    if (values && parseInt(values[0], 10) > 0) {
      challengeOver = false;
    }
  });
  // let challengeCompetitors = {};
  // let propsChallengeCompetitors = [];
  const joinOrLeave = (challenge.id !== 53) ? !challengeOver && (challenge.challenge_status === 'joined' ? 0 : 1) : (challenge.challenge_status === 'joined' ? 0 : 1);

  // if (challenge.challenge_type === 'new_group') {
  //   const { user_details: userDetails } = userChallengeDetails;
  //   propsChallengeCompetitors = userDetails;
  // } else {
  //   propsChallengeCompetitors = userChallengeDetails['user_details'];
  // }

  // const valid = convertDateInTimezone(challenge.end_date)._d >= moment()._d;

  // if (challenge.challenge_status !== 'over' || valid) {
  //   challengeCompetitors = propsChallengeCompetitors;
  // } else if (userChallengeDetails) {
  //   challengeCompetitors = propsChallengeCompetitors;
  // }

  let today = moment()._d;
  let startDay = convertDateInTimezone(challenge.start_date)._d;

  const CurrentDay = moment(); // current moment
  const ChallengestartDay = moment(convertDateInTimezone(challenge.start_date));

  const lastDayToJoin = challenge?.last_date_to_join
    ? moment(convertDateInTimezone(challenge?.last_date_to_join)._d)
    : null;

  const isPastJoinDate = lastDayToJoin ? CurrentDay.isAfter(lastDayToJoin, 'day') : false;
  const buttonStatus = challenge.is_user_allowed_to_join ? true : false;
  let daysRemaining = Math.ceil(ChallengestartDay.diff(CurrentDay, 'hours') / 24);

  let daysDifference = challenge && (new Date(challenge.end_date) - new Date(challenge.start_date)) / (1000 * 60 * 60 * 24);
  const DistanceUnit = localStorage.getItem('DISTANCE');
  let Last_Day = challenge.last_date_to_join !== null ? (convertMonthFromDate(moment(convertDateInTimezone(challenge?.last_date_to_join)._d).format(' MMMM D, YYYY'), t)) : null;




  const joinChallenge = (challengeId, isJoined) => {
    setIsButtonDisabled(true);
    window.setTimeout(() => {
      setIsButtonDisabled(false);
    }, 2000);
    const data = {
      challenge_id: challengeId,
      is_joined: isJoined
    };
    dispatch(joinOrLeaveChallenge(data));
  };

  const users = teamChallenge && teamChallenge.team_challenge_details && teamChallenge.team_challenge_details.team_details && teamChallenge.team_challenge_details.team_details.team_users && teamChallenge.team_challenge_details.team_details.team_users.length > 0 && teamChallenge.team_challenge_details.team_details.team_users || [];

  let loggedInUser;
  for (let i = 0; i < users.length; i++) {
    if (users[i].uid === user.uid) {
      loggedInUser = users[i]
    }
  }



  if ((!(userChallengeDetails))) {
    return <Waiting />
  } else {
    return (
      <>
        <CommonRightCard isMargin={"0px 0px 28px 0px"}>
          {(challenge.is_joined === 0 && Last_Day !== null) ?<Timer data={moment(convertDateInTimezone(Last_Day)._d)} startText={"Last day to join :"} isBackgroundColor={'#FCF2F3'}width={'100%'} margin={"0px 0px 20px 0px"}/>:null}
          {
            challenge.challenge_status == 'over' && teamChallenge && teamChallenge.team_challenge_details && teamChallenge.team_challenge_details.team_details ?
              <CompletePointCardNew>
                <div className='width'>{"You recorded a whopping"}&nbsp;<div>{challenge?.event_type === 'Total Steps' ? `${commaSeperator(loggedInUser.steps)} ${t("Steps")}` : challenge?.event_type === 'Total Calories' ? `${commaSeperator(loggedInUser.calories)} calories` : `${commaSeperator(loggedInUser.calories)} Miles`}&nbsp;{"in just"}&nbsp;{`${Math.floor(daysDifference)} ${Math.floor(daysDifference) > 1 ? "Days" : "Day"}`}</div></div>
                <div className='width'><div>{"earning"}&nbsp;{challenge?.rewarded_points} Points!</div></div>
              </CompletePointCardNew> :
              challenge.is_joined !== 1 && challenge.challenge_status == 'over' ?
                <CompletePointCardNew>
                  <div className='width'>Challenge Completed!
                  </div>
                </CompletePointCardNew> :

                challenge.is_joined !== 1 ?
                  <div className={isPastJoinDate || !buttonStatus ? "disableButton" : "jointButton"} onClick={isButtonDisabled || isPastJoinDate || !buttonStatus ? null : () => joinChallenge(challenge.id, joinOrLeave)}>Join Challenge</div> : null}

          {(challenge.challenge_status == 'joined' && today < startDay) && teamChallenge && teamChallenge.team_challenge_details && teamChallenge.team_challenge_details.team_details ?
            <CompletePointCardNew>
              <div className='width'>{`Just ${daysRemaining} days to go until your challenge begins!`}
              </div>
            </CompletePointCardNew> : null}


          {(challenge.challenge_status === 'joined' && today >= startDay) && teamChallenge && teamChallenge.team_challenge_details && teamChallenge.team_challenge_details.team_details &&
            <ProfileContainer>


              {((tabValue === 1) || (tabValue === 3) || (tabValue === 2 && challenge.is_team_challenge !== 1)) && (<div style={{ display: "flex", gap: "20px" }}>
                {loggedInUser.profile_image !== "profile-Image/default.png" ?
                  <LazyImage
                    style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "48px",
                      border: "1px solid  #DCDCDC",
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                    src={`${ImageUrl}/${loggedInUser.profile_image}`
                    }
                  />
                  :
                  <NameInitials id="name-initials">
                    {getInitials(loggedInUser?.name)}
                  </NameInitials>
                }
                <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                  <div className="challengeNameContainer">Hi, {loggedInUser?.name}</div>
                  <div className="challengeMessage">Here’s what you accomplished today</div>
                </div>
              </div>)}

              {(tabValue === 2 && challenge.is_team_challenge === 1) &&
                (<div style={{ display: "flex", gap: "20px" }}>
                  {(challenge?.team_challenge_details?.team_details?.logo !== "profile-Image/default.png" && challenge?.team_challenge_details?.team_details?.logo) ?
                    <LazyImage
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "48px",
                        border: "1px solid  #DCDCDC",
                      }}
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                      src={`${ImageUrl}/${challenge?.team_challenge_details?.team_details?.logo}`
                      }
                    />
                    :
                    <NameInitials id="name-initials">
                      {getInitials(challenge?.team_challenge_details?.team_details?.name)}
                    </NameInitials>
                  }
                  <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                    <div className="challengeNameContainer">Hi, {challenge?.team_challenge_details?.team_details?.name}</div>
                    <div className="challengeMessage">Here’s your team ranking summary</div>
                  </div>
                </div>)}



              {tabValue !== 2 ? <Divider id="divider" isMargin={"20px 0px"}></Divider> : null}


              {(tabValue === 2 && challenge.is_team_challenge === 0) ?
                <div className="leaderboardConatainer">
                  {(challenge.challenge_status === 'joined' || challenge.challenge_status === 'over') && !isEmpty(teamChallenge.team_challenge_details.team_details) && challenge.event_type === 'Total Steps' ?
                    (<div className="challengeDetails profileSubContainer">
                      <ChallengeTypeContainer isBackgroundColor="#92A4DA" >{StepsIcon()}</ChallengeTypeContainer>
                      {isNull(teamChallenge.team_challenge_details.team_details) ? <div className="rankText">Rank: 0</div> :
                        (today < startDay) ? <div className="rankText">-</div> :
                          <div className="rankText">Rank: {teamChallenge.team_challenge_details.team_details.team_position}{rankingDashboard(teamChallenge.team_challenge_details.team_details.team_position - 1)}</div>}
                      <div className="challengeTypesUnit"> {(teamChallenge.team_challenge_details.team_details) !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{commaSeperator(loggedInUser.steps)} Steps
                      </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                    </div>) :
                    challenge.event_type === 'Total Calories' ?
                      (<div className="challengeDetails profileSubContainer">
                        <ChallengeTypeContainer isBackgroundColor="#B1AA56">{CaloriesIcon()}</ChallengeTypeContainer>
                        {isNull(teamChallenge.team_challenge_details.team_details) ? <div className="rankText">Rank: 0</div> :
                          (today < startDay) ? <div className="rankText">-</div> :
                            <div className="rankText">Rank: {teamChallenge.team_challenge_details.team_details.team_position}{rankingDashboard(teamChallenge.team_challenge_details.team_details.team_position - 1)}</div>}
                        <div className="challengeTypesUnit">  {(teamChallenge.team_challenge_details.team_details) !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{commaSeperator(loggedInUser.calories)} Calories
                        </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                      </div>) :
                      (<div className="challengeDetails profileSubContainer">
                        <ChallengeTypeContainer isBackgroundColor="#DA6C74">{DisatanceIcon()}</ChallengeTypeContainer>

                        {isNull(teamChallenge.team_challenge_details.team_details.team_position) ? <div className="rankText">Rank: 0</div> :
                          (today < startDay) ? <div className="rankText">-</div> :
                            <div className="rankText">Rank: {teamChallenge.team_challenge_details.team_details.team_position}{rankingDashboard(teamChallenge.team_challenge_details.team_details.team_position - 1)}</div>}

                        <div className="challengeTypesUnit"> {(teamChallenge.team_challenge_details.team_details) !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{DistanceUnit === "KILOMETER" ? `${commaSeperator(convertMilesToKm(loggedInUser.distance))} Km` : `${commaSeperator(loggedInUser.distance)} Miles`}
                        </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                      </div>)}
                </div> :


                (tabValue === 2 && challenge.is_team_challenge === 1) ?
                  <div className="leaderboardConatainer">
                    {(challenge.challenge_status === 'joined' || challenge.challenge_status === 'over') && !isEmpty(challenge?.team_challenge_details) && challenge.event_type === 'Total Steps' ?
                      (<div className="challengeDetails profileSubContainer">
                        <ChallengeTypeContainer isBackgroundColor="#92A4DA" >{StepsIcon()}</ChallengeTypeContainer>
                        {isNull(challenge?.team_challenge_details?.team_details?.team_position) ? <div className="rankText">Rank: 0</div> :
                          (today < startDay) ? <div className="rankText">-</div> :
                            <div className="rankText">Rank: {challenge?.team_challenge_details?.team_details?.team_position}{rankingDashboard(challenge?.team_challenge_details?.team_details?.team_position - 1)}</div>}
                        <div className="challengeTypesUnit"> {challenge?.team_challenge_details?.team_details?.team_contribution !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{commaSeperator(challenge?.team_challenge_details?.team_details?.team_contribution)} Steps
                        </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                      </div>) :
                      challenge.event_type === 'Total Calories' ?
                        (<div className="challengeDetails profileSubContainer">
                          <ChallengeTypeContainer isBackgroundColor="#B1AA56">{CaloriesIcon()}</ChallengeTypeContainer>
                          {isNull(challenge?.team_challenge_details?.team_details?.team_position) ? <div className="rankText">Rank: 0</div> :
                            (today < startDay) ? <div className="rankText">-</div> :
                              <div className="rankText">Rank: {challenge?.team_challenge_details?.team_details?.team_position}{rankingDashboard(challenge?.team_challenge_details?.team_details?.team_position - 1)}</div>}
                          <div className="challengeTypesUnit">  {challenge?.team_challenge_details?.team_details?.team_contribution !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{commaSeperator(challenge?.team_challenge_details?.team_details?.team_contribution)} Calories
                          </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                        </div>) :
                        (<div className="challengeDetails profileSubContainer">
                          <ChallengeTypeContainer isBackgroundColor="#DA6C74">{DisatanceIcon()}</ChallengeTypeContainer>

                          {isNull(challenge?.team_challenge_details?.team_details?.team_position) ? <div className="rankText">Rank: 0</div> :
                            (today < startDay) ? <div className="rankText">-</div> :
                              <div className="rankText">Rank: {challenge?.team_challenge_details?.team_details?.team_position}{rankingDashboard(challenge?.team_challenge_details?.team_details?.team_position - 1)}</div>}

                          <div className="challengeTypesUnit"> {challenge?.team_challenge_details?.team_details?.team_contribution !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{DistanceUnit === "KILOMETER" ? `${commaSeperator(convertMilesToKm(challenge?.team_challenge_details?.team_details?.team_contribution))} Km` : `${commaSeperator(challenge?.team_challenge_details?.team_details?.team_contribution)} Miles`}
                          </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                        </div>)}
                  </div>

                  :

                  (challenge.challenge_status === 'joined' || challenge.challenge_status === 'over') && challenge.event_type === 'Total Steps' ?
                    (<div className="challengeDetails profileSubContainer">
                      <ChallengeTypeContainer isBackgroundColor="#92A4DA" >{StepsIcon()}</ChallengeTypeContainer>
                      <div className="challengeTypesUnit"> {loggedInUser.steps !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{commaSeperator(loggedInUser.steps)} Steps
                      </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                    </div>) :
                    challenge.event_type === 'Total Calories' ?
                      (<div className="challengeDetails profileSubContainer">
                        <ChallengeTypeContainer isBackgroundColor="#B1AA56">{CaloriesIcon()}</ChallengeTypeContainer>
                        <div className="challengeTypesUnit">  {loggedInUser.calories !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{commaSeperator(loggedInUser.calories)} Calories
                        </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                      </div>) :
                      (<div className="challengeDetails profileSubContainer">
                        <ChallengeTypeContainer isBackgroundColor="#DA6C74">{DisatanceIcon()}</ChallengeTypeContainer>
                        <div className="challengeTypesUnit"> {loggedInUser.distance !== null ? (today < startDay) ? <div>-</div> : <div className="challengeTypeData">{DistanceUnit === "KILOMETER" ? ` ${commaSeperator(convertMilesToKm(loggedInUser.distance))} Km ` : ` ${commaSeperator(loggedInUser.distance)} Miles`}
                        </div> : (today < startDay) ? <div>-</div> : <div>0</div>}</div>
                      </div>)
              }

            </ProfileContainer>}

          <div className="detailsContainer">
            <ManagerIconContainer isBehaviour={"default"}>{CalendarChallengeIcon()}</ManagerIconContainer>
            <div className="challengeDetails"> {(lang != "fr") ? (convertMonthFromDate(moment(convertDateInTimezone(challenge.start_date)._d).format('ddd, Do MMM YYYY'), t)) : (convertMonthFromDate(moment(convertDateInTimezone(challenge.start_date)._d).format('ddd, Do MMM YYYY'), t))} - {(lang != "fr") ? (convertMonthFromDate(moment(convertDateInTimezone(challenge.end_date)._d).format('ddd, Do MMM YYYY'), t)) : (convertMonthFromDate(moment(convertDateInTimezone(challenge.end_date)._d).format('ddd, Do MMM YYYY'), t))}</div>
          </div>

          <Divider id="divider" isMargin={"12px 0px"}></Divider>
          <div className="detailsContainer">
            <ManagerIconContainer isBehaviour={"default"}>{LocationChallengeIcon()}</ManagerIconContainer>
            <div className="challengeDetails">{challenge.challenge_location}</div>
          </div>

          {challenge.challenge_point ? <><Divider id="divider" isMargin={"12px 0px"}></Divider>
            <div className="detailsContainer">
              <ManagerIconContainer isBehaviour={"default"}>{RewardsChallengeIcon()}</ManagerIconContainer>
              <div className="challengeDetails">+{challenge.challenge_point} Points</div>
            </div> </>: null}

          <Divider id="divider" isMargin={"12px 0px"}></Divider>
          {challenge.is_team_challenge === 1 ? (<> <div className="detailsContainer">
            <ManagerIconContainer isBehaviour={"default"}>{PeopleChallengeIcon()}</ManagerIconContainer>
            <div className="challengeDetails" >{challenge?.team && challenge?.team?.length} {(challenge?.team && challenge?.team?.length) > 1 ? "Teams" : " Team"}</div>
          </div>  <Divider id="divider" isMargin={"12px 0px 28px 0px"}></Divider></>)
            : (<> <div className="detailsContainer">
              <ManagerIconContainer isBehaviour={"default"}>{PeopleChallengeIcon()}</ManagerIconContainer>
              <div className="challengeDetails" >{challengeAttendees && challengeAttendees?.length} {(challengeAttendees && challengeAttendees?.length) > 1 ? "Attendees" : " Attendee"}</div>
            </div>  <Divider id="divider" isMargin={"12px 0px 28px 0px"}></Divider></>)}



          {/* {(challenge.is_joined === 0 && Last_Day !== null) ? <div className="lasDay">The last day to join this challenge is {Last_Day}.</div> : null} */}
          {(challenge.challenge_status === 'joined' && challenge.is_user_challenge && !isEmpty(teamChallenge.team_challenge_details.team_details) && teamChallenge.team_challenge_details.team_details) ? <div className="jointButton" onClick={() => showHideInviteAmigoPopup()}>
            <div>{InviteChallengeIcon()}</div>
            <div >Invite Friends</div>
          </div> : null}
          {challenge.challenge_status === 'over'?null: ((role==="WELLNESS_ADMIN" || role==="CONTENT_CREATOR" && challenge?.challenge_status === 'joined') || (role ==="ADMIN")) && tabValue === 2 && hasCompanyInRoute && !challenge?.is_user_challenge && <HoverIconWrapper justify="space-between" margin="28px 0 0 0">
            <CommonButtonBorder onClick={challenge.is_team_challenge?()=>onAddUserPopup('Add', 'team'):  ()=>onAddUserPopup('Add')}>{AddUserIcon()}{challenge.is_team_challenge?"Add Team":"Add User"}</CommonButtonBorder>
            <CommonButtonBorder onClick={challenge.is_team_challenge?()=>onAddUserPopup('Remove', 'team'):()=>onAddUserPopup('Remove')}>{RemoveUserIcon()}{challenge.is_team_challenge?"Remove Team": "Remove User"}</CommonButtonBorder>
          </HoverIconWrapper>}
          <Suspense fallback={<Waiting />}><InviteAmigoPopUp userId={userId} history={history} showModal={showInviteAmigoPopup} onHide={showHideInviteAmigoPopup} challengeId={challenge.id} plusAmigoButton={1} hideInviteAmigoPopup={hideInviteAmigoPopup} /></Suspense>
        </CommonRightCard>
      </>
    )
  }
}


ClassicTeamRightScreen.propTypes = {
  challenge: PropTypes.object.isRequired,
  userId: PropTypes.string.isRequired,
  teamChallenge: PropTypes.object.isRequired,
  history: PropTypes.object,
  tabValue: PropTypes.number,
  user: PropTypes.object,
  getUserOverviewDetails: PropTypes.func,
  hasCompanyInRoute: PropTypes.bool,
  onAddUserPopup: PropTypes.func,
  role: PropTypes.string,
  companyId:PropTypes.number
};



export default (ClassicTeamRightScreen);
